"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const components_1 = require("../components");
/**
 * Wraps the given node in a stasis. If a plain HTML element is provided
 * a React wrapper (host or carrier) is created.
 * @param content The content to be wrapped.
 * @param options The options to consider.
 * @returns A React node wrapping the content.
 */
function wrapElement(content, options = {}) {
    const { wrapper = 'div' } = options, stasisOptions = tslib_1.__rest(options, ["wrapper"]);
    if (content instanceof HTMLElement) {
        const htmlNode = content;
        content = React.createElement(wrapper, {
            ref(host) {
                host && host.appendChild(htmlNode);
            },
        });
    }
    return React.createElement(components_1.ArbiterStasis, Object.assign({}, stasisOptions), content);
}
exports.wrapElement = wrapElement;
